import { DiscountCodeType, type TDiscount } from "@./suf-store";
import {
  formatDiscount,
} from "apps/website/components/pages/flows/fresh/sign-up/Pricing/utils";
import { useTranslations } from "next-intl";

/**
 * Builds the promotional banner text for a discount.
 *
 * Shared between FreshSignupFlow and DirectSalesFlow, which use the same
 * announcement keys under different namespaces.
 */
export const getAnnouncementText = (
  discount: TDiscount,
  bannerT: ReturnType<typeof useTranslations>,
): string => {
  const formattedDiscount = formatDiscount(discount);
  if (!formattedDiscount) {
    return bannerT("announcementFallback");
  }
  return discount.type === DiscountCodeType.ABSOLUTE_TOTAL
    ? bannerT("announcementAbsolute", { discount: formattedDiscount })
    : bannerT("announcementOff", { discount: formattedDiscount });
};
